import { useEffect } from 'react'

import { ClientsPageHeader, ClientsTable } from '@/components/pages/Client'
import { useClient } from '@/pages/Client/Client.hooks'

const Client = () => {
  const { getClients, loading, response } = useClient()
  const dataSource = response ?? []

  useEffect(() => {
    getClients()
  }, [getClients])

  return (
    <>
      <ClientsPageHeader />
      <ClientsTable {...{ dataSource, loading }} />
    </>
  )
}

Client.displayName = 'Client'
export default Client
